import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useProductAddOns from '@/shared/product/add-ons/useProductAddOns';
import { ProductAddOnTileModel } from '@/types/B2CcontentServerContract';
import { onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductAddOnTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: ProductAddOnTileModel
}



const { register, unregister } = useProductAddOns();

register(props.content);

onBeforeUnmount(() => {
    unregister();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})